import { MutationTree } from "vuex";
import { IdomStateInterface } from "./state";
import {
  IdomBotItem,
  IdomChannelItem,
  IdomEntityItem,
  IdomMessagingPolicy,
  IdomSettings,
  IdomAutosendOption,
  IdomPlatform,
  IdomRole,
  IdomEntityType,
} from "../../models";

const mutation: MutationTree<IdomStateInterface> = {
  setIdomEntityTypes(
    state: IdomStateInterface,
    payload: {
      entityGuid: string;
      types: IdomEntityType[];
    },
  ) {
    const index = state.entities.findIndex(
      (entity) => entity.guid === payload.entityGuid,
    );
    if (index === -1) {
      return;
    }
    state.entities[index].entity_types = payload.types;
  },
  setIdomSettings(state: IdomStateInterface, payload: IdomSettings) {
    payload.policyValue = payload.policy.value;
    state.settings = payload;
  },
  setIdomUserMap(state: IdomStateInterface, payload: string[]) {
    state.userTags = payload;
  },
  setTlgrmPolicies(state: IdomStateInterface, payload: IdomMessagingPolicy[]) {
    state.policies = payload.map((v, i, a) => {
      v.label = v.name;
      return v;
    });
  },
  setIdomMessagingPolicy(
    state: IdomStateInterface,
    payload: IdomMessagingPolicy,
  ) {
    state.settings.policy = payload;
  },
  setIdomSendingEnabled(state: IdomStateInterface, payload: boolean) {
    state.settings.premoderate_sending_enabled = payload;
  },
  setIdomChannels(state: IdomStateInterface, payload: IdomChannelItem[]) {
    state.channels = payload;
  },
  setIdomChannelCount(state: IdomStateInterface, payload: number) {
    state.botsCount = payload;
  },
  setIdomBots(state: IdomStateInterface, payload: IdomBotItem[]) {
    state.bots = payload;
  },
  setBotsCount(state: IdomStateInterface, payload: number) {
    state.botsCount = payload;
  },
  setPlatforms(state: IdomStateInterface, payload: IdomPlatform[]) {
    state.platforms = payload;
  },
  setRoles(state: IdomStateInterface, payload: IdomRole[]) {
    state.roles = payload;
  },
  setAutosendOptions(state: IdomStateInterface, payload: IdomAutosendOption[]) {
    state.autosendOptions = payload;
  },
  setTlgrmEntities(state: IdomStateInterface, payload: IdomEntityItem[]) {
    state.entities = payload.map((v, i, a) => {
      v.num = i + 1;
      return v;
    });
  },
  setTlgrmEntitiesCount(state: IdomStateInterface, payload: number) {
    state.entitiesCount = payload;
  },
  setBotState(state: IdomStateInterface, { account_guid, enabled }) {
    const index = state.bots.findIndex((v) => {
      return v.account_guid == account_guid;
    });

    if (index >= 0) {
      const botState = state.bots[index];
      botState.enabled = enabled;
      state.bots[index] = botState;
    } else {
      console.error("Idom::mutations.setBotState");
    }
  },
  setBotRole(state: IdomStateInterface, { account_guid, role_guid }) {
    const index = state.bots.findIndex((v) => {
      return v.account_guid == account_guid;
    });

    if (index >= 0) {
      const botState = state.bots[index];
      Object.assign(botState.role_guid, role_guid);
      state.bots[index] = botState;
    } else {
      console.error("Idom::mutations.setBotRole");
    }
  },
  setBotCredentials(state: IdomStateInterface, { account_guid, credentials }) {
    const index = state.bots.findIndex((v) => {
      return v.account_guid == account_guid;
    });

    if (index >= 0) {
      const botState = state.bots[index];
      Object.assign(botState.credentials, credentials);
      state.bots[index] = botState;
    } else {
      console.error("Idom::mutations.setBotCredentials");
    }
  },
  setChannelState(
    state: IdomStateInterface,
    { guid, enabled, autosend_option_guid },
  ) {
    const index = state.channels.findIndex((v) => {
      return v.guid == guid;
    });

    if (index >= 0) {
      const channelState = state.channels[index];
      channelState.autosend_option_guid = autosend_option_guid;
      channelState.enabled = enabled;
      state.channels[index] = channelState;
    } else {
      console.error("Idom::mutations.setChannelState");
    }
  },
  setEntityState(
    state: IdomStateInterface,
    { guid, enabled, autosend, push_mode },
  ) {
    const index = state.entities.findIndex((v, i, o) => {
      return v.guid === guid;
    });

    if (index >= 0) {
      console.log(guid, enabled, autosend, push_mode);
      const newEntityState = state.entities[index];
      newEntityState.enabled = enabled;
      newEntityState.autosend = autosend;
      newEntityState.push_mode = push_mode;
      state.entities[index] = newEntityState;
    } else {
      console.error("Idom::mutations.updateEntityState");
    }
  },
  //#endregion
};

export default mutation;
